import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipPath: "url(#profile-2-clip)",
		clipRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M9 8.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6" }), /* @__PURE__ */ _jsx("path", { d: "M17.25 9A8.25 8.25 0 1 1 .75 9a8.25 8.25 0 0 1 16.5 0m-4.336 5.5A6.72 6.72 0 0 1 9 15.75a6.72 6.72 0 0 1-3.914-1.25A5.24 5.24 0 0 1 9 12.75c1.555 0 2.951.675 3.914 1.75m1.117-1A6.73 6.73 0 0 0 9 11.25c-2 0-3.796.87-5.031 2.25a6.75 6.75 0 1 1 10.062 0" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "profile-2-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
export default SvgProfile2;
